var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wide-screen"},[_c('iframe',{attrs:{"src":_vm.routeProgressUrl}}),_c('iframe',{attrs:{"src":_vm.marketingUrl}}),_c('div',{staticClass:"hidden-on-widescreen"},[_vm._v("Kolumbus")])])}
var staticRenderFns = []

export { render, staticRenderFns }